class AuthProvider {
  private static instance: AuthProvider;
  private tokenGenerator?: () => Promise<string>;

  private constructor() {}

  setTokenGenerator(tokenGenerator: () => Promise<string>) {
    this.tokenGenerator = tokenGenerator;
  }

  removeTokenGenerator() {
    this.tokenGenerator = undefined;
  }

  async generateToken() {
    if (!this.tokenGenerator) {
      throw new Error("tokenGenerator accessed without initialization");
    }
    const token = await this.tokenGenerator();
    // The Auth0 SDK types getTokenSilently as Promise<string> but can resolve
    // undefined when it decides the session is over. Without this check the
    // undefined reaches callers that build a "Bearer ${token}" header and only
    // fails later as an opaque 401.
    if (typeof token !== "string" || token.length === 0) {
      throw new Error("Auth0 returned an empty token");
    }
    return token;
  }

  ready(): boolean {
    return !!this.tokenGenerator;
  }

  public static get Instance() {
    return this.instance || (this.instance = new this());
  }
}

export default AuthProvider.Instance;
